"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = function _default() {
  return {
    name: 'list',
    synopsis: 'list [ITEM] ...[ITEMS]',
    description: 'Convert arguments to a list',
    execute: function execute(args) {
      return [args];
    }
  };
};

exports.default = _default;